/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import {
  // formatNumber,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../../lib/Misc";
import Spin from "../../../components/Spin";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import { CardTitle } from "../../../components/ui/card";
import {
  amlctfIndictorOptions,
  API,
  bniIndicatorOptions,
  bniTypeOptions,
  get,
  incidentMovementTypeOptions,
  incidentPaymentMethodOptions,
  incidentTransactionType,
  // incidentMethodType,
  incidentTypeOptions,
  suspicionTypeOptions,
} from "../../../config";
import { useOrganization } from "../../../lib/context/OrganisationContext";
import moment from "moment";

const IncidentDetailsPopup = ({
  incidentId,
  // toggleShowModal,
  showView,
  setShowView,
}) => {
  const [incidentDetail, setIncidentDetail] = useState(null);
  const [incidentLoading, setIncidentLoading] = useState(true);
  const { organizationData } = useOrganization();

  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await get(`${API.INCIDENT_DETAILS}/` + incidentId);
        setIncidentDetail(data.data);
        setIncidentLoading(false);
      } catch (e) {
        return null;
      }
    }
    fetchData();
  }, [incidentId, setIncidentDetail]);

  // const transactionType = [
  //   { label: "Credit", value: "1" },
  //   { label: "Debit", value: "0" },
  // ];

  return (
    <ResponsiveDrawerForm
      description={""}
      title={`Incident Details`}
      handleOpen={() => {}}
      handleClose={() => {}}
      className={"md:w-[65vw]"}
      open={showView}
      buttonClassName={""}
      popupType={"incidents"}
      setOpen={setShowView}
      read={true}
    >
      <>
        {incidentLoading ? (
          <Spin full expand={true} />
        ) : (
          <div className="md:p-0 p-4">
            <div className="modal-content">
              <CardTitle className="text-md mb-2">Incident Details </CardTitle>
              <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                <p>
                  <strong>Incident Type:</strong>{" "}
                  {incidentDetail?.incident_type
                    ? incidentTypeOptions?.find(
                        (item) => item.value === incidentDetail?.incident_type,
                      )?.label
                    : "-"}
                </p>
                <p>
                  <strong>Contact Type:</strong>{" "}
                  {incidentDetail?.contactable_type
                    ? incidentDetail?.contactable_type === "vendor"
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "vendors",
                          "Vendor",
                        )
                      : incidentDetail?.contactable_type === "contact"
                        ? getModuleNamingBySlug(
                            organizationData?.organizationData,
                            "contacts",
                            "Customer",
                          )
                        : ""
                    : ""}
                </p>
                <p>
                  <strong>
                    {incidentDetail?.contactable_type
                      ? incidentDetail?.contactable_type === "vendor"
                        ? getModuleNamingBySlug(
                            organizationData?.organizationData,
                            "vendors",
                            "Vendor",
                          )
                        : incidentDetail?.contactable_type === "contact"
                          ? getModuleNamingBySlug(
                              organizationData?.organizationData,
                              "contacts",
                              "Customer",
                            )
                          : ""
                      : ""}
                    :
                  </strong>{" "}
                  {incidentDetail?.contactable
                    ? formatSubcontractorName(incidentDetail?.contactable)
                    : "-"}
                </p>
                {incidentDetail?.contactable_type === "vendor" && (
                  <>
                    {incidentDetail?.asset?.name && (
                      <p>
                        <strong>
                          {getModuleNamingBySlug(
                            organizationData?.organizationData,
                            "assets",
                            "Asset",
                          )}
                          :
                        </strong>{" "}
                        {incidentDetail?.asset?.name
                          ? incidentDetail?.asset?.name
                          : "-"}
                      </p>
                    )}
                    {incidentDetail?.sub_asset?.name && (
                      <p>
                        <strong>
                          {getModuleNamingBySlug(
                            organizationData?.organizationData,
                            "sub-assets",
                            "Sub Asset",
                          )}
                          :
                        </strong>{" "}
                        {incidentDetail?.sub_asset?.name
                          ? incidentDetail?.sub_asset?.name
                          : "-"}
                      </p>
                    )}
                  </>
                )}
                <p>
                  <strong>Review Date:</strong>{" "}
                  {incidentDetail?.review_date
                    ? moment(incidentDetail?.review_date, "YYYY-MM-DD")?.format("DD-MM-YYYY")
                    : "-"}
                </p>
                <p>
                  <strong>Review By:</strong>{" "}
                  {incidentDetail?.review_by
                    ? formatSubcontractorName(incidentDetail?.review_by)
                    : "-"}
                </p>

                <p>
                  <strong>Incident Date:</strong>{" "}
                  {incidentDetail?.incident_date
                    ? incidentDetail?.incident_date
                    : "-"}
                </p>

                {incidentDetail?.incident_type == 0 ? (
                  <>
                    <p>
                      <strong>Suspicion Type:</strong>{" "}
                      {incidentDetail?.details?.suspicion_type
                        ? suspicionTypeOptions?.find(
                            (item) =>
                              item.value ==
                              incidentDetail?.details?.suspicion_type,
                          )?.label
                        : "-"}
                    </p>

                    <p>
                      <strong>AML/CTF Indicator:</strong>{" "}
                      {incidentDetail?.details?.aml_ctf_indicator
                        ? amlctfIndictorOptions?.find(
                            (item) =>
                              item.value ==
                              incidentDetail?.details?.aml_ctf_indicator,
                          )?.label
                        : "-"}
                    </p>

                    <p>
                      <strong>Activity Date From:</strong>{" "}
                      {incidentDetail?.details?.activity_date_from || "-"}
                    </p>

                    <p>
                      <strong>Activity Date To:</strong>{" "}
                      {incidentDetail?.details?.activity_date_to || "-"}
                    </p>

                    <p>
                      <strong>SMR Amount:</strong>{" "}
                      {incidentDetail?.details?.smr_amount || "-"}
                    </p>

                    <p>
                      <strong>SMR Currency:</strong>{" "}
                      {incidentDetail?.details?.smr_currency_name || "AUD"}
                    </p>

                    <p>
                      <strong>Countries Involved:</strong>{" "}
                      {incidentDetail?.details?.countries_involved_name
                        ? incidentDetail?.details?.countries_involved_name?.join(
                            ", ",
                          )
                        : "-"}
                    </p>

                    <p>
                      <strong>Grounds for Suspicion:</strong>{" "}
                      {incidentDetail?.details?.grounds_for_suspicion || "-"}
                    </p>

                    <p>
                      <strong>Investigation Summary:</strong>{" "}
                      {incidentDetail?.details?.investigation_summary || "-"}
                    </p>

                    <p>
                      <strong>Customer Explanation:</strong>{" "}
                      {incidentDetail?.details?.customer_explanation || "-"}
                    </p>

                    <p>
                      <strong>Previous SMR Reference:</strong>{" "}
                      {incidentDetail?.details?.previous_smr_reference || "-"}
                    </p>
                  </>
                ) : incidentDetail?.incident_type == 1 ? (
                  <>
                    <p>
                      <strong>Transactor Name:</strong>{" "}
                      {incidentDetail?.details?.transactor_name || "-"}
                    </p>

                    <p>
                      <strong>Transactor ID:</strong>{" "}
                      {incidentDetail?.details?.transactor_id || "-"}
                    </p>

                    <p>
                      <strong>Transaction Date & Time:</strong>{" "}
                      {incidentDetail?.details?.transaction_date_time || "-"}
                    </p>

                    <p>
                      <strong>Amount:</strong>{" "}
                      {incidentDetail?.details?.amount || "-"}
                    </p>

                    <p>
                      <strong>Currency:</strong>{" "}
                      {incidentDetail?.details?.currency_name || "AUD"}
                    </p>

                    <p>
                      <strong>AUD Equivalent:</strong>{" "}
                      {incidentDetail?.details?.aud_equivalent || "-"}
                    </p>

                    <p>
                      <strong>Transaction Type:</strong>{" "}
                      {incidentDetail?.details?.transaction_type
                        ? incidentTransactionType?.find(
                            (item) =>
                              item.value ==
                              incidentDetail?.details?.transaction_type,
                          )?.label
                        : "-"}
                    </p>

                    <p>
                      <strong>Product / Service:</strong>{" "}
                      {incidentDetail?.details?.product_service || "-"}
                    </p>

                    <p>
                      <strong>Account Number:</strong>{" "}
                      {incidentDetail?.details?.account_number || "-"}
                    </p>

                    <p>
                      <strong>Branch Location:</strong>{" "}
                      {incidentDetail?.details?.branch_location || "-"}
                    </p>

                    <p>
                      <strong>Transaction Purpose:</strong>{" "}
                      {incidentDetail?.details?.transaction_purpose || "-"}
                    </p>
                  </>
                ) : incidentDetail?.incident_type == 2 ? (
                  <>
                    <p>
                      <strong>Ordering Party Name:</strong>{" "}
                      {incidentDetail?.details?.ordering_party_name || "-"}
                    </p>

                    <p>
                      <strong>Ordering Party Account:</strong>{" "}
                      {incidentDetail?.details?.ordering_party_account || "-"}
                    </p>

                    <p>
                      <strong>Beneficiary Name:</strong>{" "}
                      {incidentDetail?.details?.beneficiary_name || "-"}
                    </p>

                    <p>
                      <strong>Beneficiary Account:</strong>{" "}
                      {incidentDetail?.details?.beneficiary_account || "-"}
                    </p>

                    <p>
                      <strong>Transfer Date & Time:</strong>{" "}
                      {incidentDetail?.details?.transfer_date_time || "-"}
                    </p>

                    <p>
                      <strong>Origin Country:</strong>{" "}
                      {incidentDetail?.details?.origin_country_name || "-"}
                    </p>

                    <p>
                      <strong>Destination Country:</strong>{" "}
                      {incidentDetail?.details?.destination_country_name || "-"}
                    </p>

                    <p>
                      <strong>Sending Institution:</strong>{" "}
                      {incidentDetail?.details?.sending_institution || "-"}
                    </p>

                    <p>
                      <strong>Receiving Institution:</strong>{" "}
                      {incidentDetail?.details?.receiving_institution || "-"}
                    </p>

                    <p>
                      <strong>Intermediary Institution:</strong>{" "}
                      {incidentDetail?.details?.intermediary_institution || "-"}
                    </p>

                    <p>
                      <strong>Payment Method:</strong>{" "}
                      {incidentDetail?.details?.payment_method
                        ? incidentPaymentMethodOptions?.find(
                            (item) =>
                              item.value ==
                              incidentDetail?.details?.payment_method,
                          )?.label
                        : "-"}
                    </p>

                    <p>
                      <strong>Payment Reference:</strong>{" "}
                      {incidentDetail?.details?.payment_reference || "-"}
                    </p>
                  </>
                ) : incidentDetail?.incident_type == 3 ? (
                  <>
                    <p>
                      <strong>Movement Type:</strong>{" "}
                      {incidentDetail?.details?.movement_type
                        ? incidentMovementTypeOptions?.find(
                            (item) =>
                              item.value ==
                              incidentDetail?.details?.movement_type,
                          )?.label
                        : "-"}
                    </p>

                    <p>
                      <strong>Movement Date & Time:</strong>{" "}
                      {incidentDetail?.details?.movement_date_time || "-"}
                    </p>

                    <p>
                      <strong>Border Port:</strong>{" "}
                      {incidentDetail?.details?.border_port || "-"}
                    </p>

                    <p>
                      <strong>BNI Indicator:</strong>{" "}
                      {incidentDetail?.details?.bni_indicator
                        ? bniIndicatorOptions?.find(
                            (item) =>
                              item.value ==
                              incidentDetail?.details?.bni_indicator,
                          )?.label
                        : "-"}
                    </p>

                    {incidentDetail?.details?.bni_indicator ? (
                      <>
                        <p>
                          <strong>BNI Type:</strong>{" "}
                          {incidentDetail?.details?.bni_type
                            ? bniTypeOptions?.find(
                                (item) =>
                                  item.value ==
                                  incidentDetail?.details?.bni_type,
                              )?.label
                            : "-"}
                        </p>
                        <p>
                          <strong>BNI Number:</strong>{" "}
                          {incidentDetail?.details?.bni_number || "-"}
                        </p>
                        <p>
                          <strong>BNI Issuer:</strong>{" "}
                          {incidentDetail?.details?.bni_issuer || "-"}
                        </p>
                        <p>
                          <strong>BNI Value:</strong>{" "}
                          {incidentDetail?.details?.bni_value || "-"}
                        </p>{" "}
                      </>
                    ) : (
                      <></>
                    )}

                    <p>
                      <strong>BNI Currency:</strong>{" "}
                      {incidentDetail?.details?.bni_currency || "AUD"}
                    </p>

                    <p className="col-span-2">
                      <strong>Funds Purpose:</strong>{" "}
                      {incidentDetail?.details?.funds_purpose || "-"}
                    </p>

                    <p className="col-span-2">
                      <strong>Funds Owner:</strong>{" "}
                      {incidentDetail?.details?.funds_owner || "-"}
                    </p>
                  </>
                ) : (
                  <></>
                )}

                <p className="col-span-2">
                  <strong>Note for Austrac:</strong>{" "}
                  {incidentDetail?.note ? incidentDetail?.note : "-"}
                </p>

                {incidentDetail?.files?.length > 0 &&
                  incidentDetail?.files.map((item, index) => (
                    <p className="col-span-2">
                      <strong>Document - {index + 1}:</strong>{" "}
                      <a
                        href={item?.url}
                        download
                        target="_blank"
                        className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 transition-colors"
                        rel="noreferrer"
                      >
                        {item?.name}
                      </a>
                    </p>
                  ))}
              </div>
            </div>
          </div>
        )}
      </>
    </ResponsiveDrawerForm>
  );
};

export default IncidentDetailsPopup;
